import { number, string, object, literal, url } from 'zod'
import { inn, phone } from './core'


let organizationBase = object({
  phone: phone.or(literal('')).transform((val: string) => val || null),
  website: url().or(literal('')).transform((val: string) => val || null)
})

export let updateOrganizationSchema = organizationBase.extend({
  id: number()
})

export let organization = organizationBase.extend({
  id: number().optional(),
  name: string().min(1),
  inn: inn,
})
